import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';

const SeedSource = ({ companiesList }) => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      id="seedSource"
      placeholder="Select seed source"
      name="seedSource"
      label="Seed Source"
      items={companiesList}
      disabled={!isEnableInfoTabEdit}
    />
  );
};

SeedSource.propTypes = {
  companiesList: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default SeedSource;
